var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgBgBlob = function SvgBgBlob(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 439,
    height: 350,
    viewBox: "0 0 439 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8916_309288)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8916_309288",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 100,
    width: 239,
    height: 150
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 100.184,
    width: 238,
    height: 149.634,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8916_309288)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 151.164,
    cy: 140.243,
    r: 71.8713,
    fill: "#0B79D0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.454,
    cy: 168.225,
    r: 50.9579,
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.454,
    cy: 168.225,
    r: 50.9579,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.735,
    cy: 250.112,
    r: 50.9579,
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.735,
    cy: 250.112,
    r: 50.9579,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.864,
    cy: 225.958,
    r: 50.9579,
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.864,
    cy: 225.958,
    r: 50.9579,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.47,
    cy: 89.2851,
    r: 50.9579,
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.47,
    cy: 89.2851,
    r: 50.9579,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.469,
    cy: 117.563,
    r: 32.6955,
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.469,
    cy: 117.563,
    r: 32.6955,
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.281,
    cy: 207.696,
    r: 32.6955,
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.281,
    cy: 207.696,
    r: 32.6955,
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.271,
    cy: 135.236,
    r: 50.3688,
    fill: "#0B79D0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.181,
    cy: 243.043,
    r: 50.3688,
    fill: "#0B79D0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306.395,
    cy: 214.177,
    r: 79.2351,
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306.395,
    cy: 214.177,
    r: 79.2351,
    fill: "white",
    fillOpacity: 0.9
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8916_309288",
    x: 0.5,
    y: 0.183594,
    width: 438,
    height: 349.634,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_8916_309288"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBgBlob);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";